<template>
  <div class="stepper-view" ref="stepperView">
    <div class="step-head pa-6 pa-md-8">
      <span class="step-nr">{{ stepLabel }}</span>
      <k-spacing y="8"></k-spacing>
      <p class="step-subtitle" v-if="!changing">
        {{ formatText() }}
      </p>
      <p class="step-subtitle" v-else>
        {{ $i18n.locale == "nl" ? "Wijzig aanmelding" : "Change registration" }}
      </p>
      <h3 class="step-title" :class="is_mobile ? 'mt-1' : 'mt-1'">
        {{
          locale === "nl"
            ? activity.content.nl.banner.title
            : activity.content.eng.banner.title
        }}
        <v-chip
          :class="activity.type === 'eenopeen' ? '' : 'group-chip'"
          color="var(--company-primary)"
          variant="tonal"
        >
          {{
            activity.type === "eenopeen"
              ? $i18n.locale === "nl"
                ? "1 OP 1"
                : "1 ON 1"
              : $i18n.locale === "nl"
              ? "GROEPSACTIVITEIT"
              : "GROUP ACTIVITY"
          }}
        </v-chip>
      </h3>
      <span class="enroll-date" v-if="changing">
        {{
          toAmsterdamCalendarDate(enroll.date)
            .toLocaleDateString("nl-NL", {
              day: "numeric",
              month: "short",
              year: "numeric",
            })
            .replace(/(\w{3})/, "$1.")
        }}
        {{ enroll.start }} -
        {{ enroll.end }}
      </span>
    </div>
    <div class="step-body px-6 px-md-8" v-if="ready">
      <label class="input-label" for="choose-specialist">
        {{ $i18n.locale == "nl" ? "Aanmeld gegevens" : "Registration details" }}
      </label>
      <k-spacing y="4"></k-spacing>
      <div v-if="registeractivity.dates.length">
        <div v-for="(dateItem, index) in registeractivity.dates" :key="index">
          <v-row class="lh-fix card-light summary-cards">
            <waitlist-badge
              v-if="slotWaitlist(dateItem.slot)"
              class="summary-cards__waitlist"
            />
            <v-col cols="12" md="3" :class="is_mobile ? '' : 'mb-4'">
              <span class="register-card-summary-text">
                {{
                  $t(
                    "components.registerActivityDialog.dialog_stepper_title_4_l_summary_4",
                  )
                }}
              </span>
            </v-col>
            <v-col cols="12" md="9" :class="is_mobile ? 'mb-6' : 'mb-4'">
              <span class="register-card-summary-answer">
                {{
                  new Date(dateItem.date)
                    .toLocaleDateString("nl-NL", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })
                    .replace(/(\w{3})/, "$1.")
                }}
              </span>
            </v-col>
            <v-col cols="12" md="3" :class="is_mobile ? '' : 'mb-4'">
              <span class="register-card-summary-text">
                {{
                  $t(
                    "components.registerActivityDialog.dialog_stepper_title_4_l_summary_5",
                  )
                }}
              </span>
            </v-col>
            <v-col cols="12" md="9" :class="is_mobile ? 'mb-6' : 'mb-4'">
              <span class="register-card-summary-answer">
                {{ dateItem.slot.start }} - {{ dateItem.slot.end }}
              </span>
            </v-col>

            <v-col cols="12" md="3" :class="is_mobile ? 'mb-1' : 'mb-4'">
              <span class="register-card-summary-text">
                {{
                  $t(
                    "components.registerActivityDialog.dialog_stepper_title_4_l_summary_3",
                  )
                }}
              </span>
            </v-col>
            <v-col cols="12" md="9" :class="is_mobile ? 'mb-6' : 'mb-4'">
              <span class="register-card-summary-answer">
                {{
                  activity.type === "eenopeen"
                    ? activity.locations[locationIndex].specialists.find(
                        (specialist) =>
                          specialist.id === dateItem.slot.activity_specialist,
                      )?.name || "Onbekend" // Use specialist from slot if "geen_voorkeur"
                    : dateItem.specialist
                }}
              </span>
            </v-col>
            <v-col cols="12" md="3" :class="is_mobile ? '' : 'mb-4'">
              <span class="register-card-summary-text">
                {{ $i18n.locale == "nl" ? "Locatie" : "Location" }}
              </span>
            </v-col>
            <v-col cols="12" md="9" :class="is_mobile ? 'mb-6' : 'mb-4'">
              <span class="register-card-summary-answer">
                {{
                  dateItem.slot.location_type == "online"
                    ? "Online"
                    : activity.locations[locationIndex].data.city
                }}
              </span>
            </v-col>
            <!-- If online -->
            <v-col
              cols="12"
              md="3"
              :class="is_mobile ? 'mb-1' : 'mb-4'"
              v-if="dateItem.slot.location_type == 'online'"
            >
              <span class="register-card-summary-text">
                {{ $i18n.locale == "nl" ? "Vergaderlink" : "Meeting link" }}
              </span>
            </v-col>

            <v-col
              cols="12"
              md="9"
              :class="is_mobile ? 'mb-6' : 'mb-4'"
              v-if="dateItem.slot.location_type == 'online'"
            >
              <span
                class="register-card-summary-answer"
                :style="{
                  opacity: !dateItem.slot.address.meeting_link ? 0.6 : 1,
                }"
              >
                <a
                  v-if="dateItem.slot.address.meeting_link"
                  target="_blank"
                  :href="dateItem.slot.address.meeting_link"
                >
                  {{ dateItem.slot.address.meeting_link }}
                </a>
                <span v-else>
                  {{
                    dateItem.slot.address.meeting_link
                      ? dateItem.slot.address.meeting_link
                      : $i18n.locale == "nl"
                      ? "Nog niet bekend"
                      : "Unknown"
                  }}
                </span>
              </span>
            </v-col>
            <v-col
              cols="12"
              md="3"
              :class="is_mobile ? 'mb-1' : 'mb-4'"
              v-if="dateItem.slot.location_type == 'online'"
            >
              <span class="register-card-summary-text">
                {{ $i18n.locale == "nl" ? "Meeting ID" : "Meeting ID" }}
              </span>
            </v-col>

            <v-col
              cols="12"
              md="9"
              :class="is_mobile ? 'mb-6' : 'mb-4'"
              v-if="dateItem.slot.location_type == 'online'"
            >
              <span
                class="register-card-summary-answer"
                :style="{
                  opacity: !dateItem.slot.address.meeting_id ? 0.6 : 1,
                }"
              >
                {{
                  dateItem.slot.address.meeting_id
                    ? dateItem.slot.address.meeting_id
                    : $i18n.locale == "nl"
                    ? "Nog niet bekend"
                    : "Unknown"
                }}
              </span>
            </v-col>
            <v-col
              cols="12"
              md="3"
              :class="is_mobile ? '' : ''"
              v-if="dateItem.slot.location_type == 'online'"
            >
              <span class="register-card-summary-text">
                {{ $i18n.locale == "nl" ? "Passcode" : "Passcode" }}
              </span>
            </v-col>

            <v-col
              cols="12"
              md="9"
              :class="is_mobile ? '' : ''"
              v-if="dateItem.slot.location_type == 'online'"
            >
              <span
                class="register-card-summary-answer"
                :style="{
                  opacity: !dateItem.slot.address.passcode ? 0.6 : 1,
                }"
              >
                {{
                  dateItem.slot.address.passcode
                    ? dateItem.slot.address.passcode
                    : $i18n.locale == "nl"
                    ? "Nog niet bekend"
                    : "Unknown"
                }}
              </span>
            </v-col>
            <v-col
              cols="12"
              md="3"
              :class="is_mobile ? '' : ''"
              v-if="dateItem.slot.location_type == 'location'"
            >
              <span class="register-card-summary-text">
                {{ $i18n.locale == "nl" ? "Ruimte" : "Room" }}
              </span>
            </v-col>

            <v-col
              cols="12"
              md="9"
              :class="is_mobile ? '' : ''"
              v-if="dateItem.slot.location_type == 'location'"
            >
              <span
                class="register-card-summary-answer"
                :style="{
                  opacity: !dateItem.slot.address.room ? 0.6 : 1,
                }"
              >
                {{
                  dateItem.slot.address.room
                    ? dateItem.slot.address.room
                    : $i18n.locale == "nl"
                    ? "Nog niet bekend"
                    : "Unknown"
                }}
              </span>
            </v-col>
          </v-row>

          <k-spacing y="4"></k-spacing>
        </div>
      </div>
      <template v-if="hasWaitlist">
        <div class="waitlist-notice d-flex">
          <div>
            <strong>{{ $t("waitlist.notice_title") }}</strong>
            <p class="mb-0">
              {{
                forSomeoneElse
                  ? $t("waitlist.notice_body_other")
                  : $t("waitlist.notice_body_self")
              }}
            </p>
          </div>
          <v-icon class="waitlist-notice__icon ml-4" size="24" color="#F5A623">
            mdi-alert-circle
          </v-icon>
        </div>
        <k-spacing y="6"></k-spacing>
      </template>
      <div v-if="showPhone">
        <label class="input-label" for="phone">
          {{ $t("components.registerActivityDialog.phone_l")
          }}{{ phoneRequired ? " *" : "" }}
        </label>
        <v-text-field
          ref="phone"
          class="mt-1"
          v-model="phone"
          variant="solo"
          type="tel"
          name="phone"
          :placeholder="$t('components.registerActivityDialog.phone_ph')"
          :rules="phoneRules"
          hide-details="auto"
          validate-on-blur
        />
        <!-- De aanmeldknop staat niet uit zonder nummer: op een laag scherm
             staat dit veld onder de vouw, achter de sticky footer en zonder
             scrollbalk, en dan zag niemand waarom de knop uit stond (ClickUp
             1240ccemvj2). Een klik haalt het veld met zijn melding in beeld. -->
        <p class="mt-2">
          {{
            forSomeoneElse
              ? $t("components.registerActivityDialog.phone_info_other")
              : $t("components.registerActivityDialog.phone_info_self")
          }}
        </p>
        <k-spacing y="6"></k-spacing>
      </div>

      <label class="input-label" for="choose-specialist">
        {{ $i18n.locale == "nl" ? "Opmerkingen" : "Remarks" }}
      </label>
      <v-textarea
        class="mt-1"
        v-model="remark"
        variant="solo"
        :rows="is_mobile ? 4 : 3"
        :placeholder="getRemarkPlaceholder()"
      ></v-textarea>
      <p>
        {{ getRemarkInfoText() }}
      </p>
      <k-spacing y="8"></k-spacing>
      <div v-if="showColleagues">
        <div class="colleague-text" for="choose-specialist">
          {{
            $t(
              "components.registerActivityDialog.dialog_stepper_title_4_l_invite",
            )
          }}
        </div>
        <k-spacing y="4"></k-spacing>

        <v-autocomplete
          variant="solo"
          class="mt-1"
          hide-details
          multiple
          no-filter
          :items="colleagueItems"
          return-object
          item-value="id"
          item-title="name"
          v-model="colleagues"
          v-model:search="colleagueSearch"
          :loading="colleaguesLoading"
          :placeholder="
            $t('components.registerActivityDialog.invite_search_placeholder')
          "
          :no-data-text="colleagueNoDataText"
          rounded="large"
        >
        </v-autocomplete>
      </div>
      <v-checkbox
        class="ml-n2 mt-6 mt-md-8"
        hide-details
        :label="getReminderLabel()"
        color="var(--company-primary)"
        v-model="reminder"
      >
      </v-checkbox>
    </div>
    <loader
      :circle_size="180"
      v-else
      :image="false"
      height="40"
      width="170"
      class="mt-16"
    />
    <div class="step-footer pa-6 pa-md-8 pt-md-10 sticky">
      <v-row>
        <v-col cols="12" :class="!is_mobile ? 'd-flex' : ''">
          <v-btn
            v-if="is_mobile"
            block
            class="btn text-white"
            color="var(--company-primary)"
            :loading="isSubmitting"
            :disabled="isSubmitting"
            @click="handleRegister"
          >
            {{ submitLabel }}
          </v-btn>
          <v-btn
            :block="is_mobile"
            v-if="firstStep"
            class="btn quickfix-btn"
            :class="is_mobile ? 'mt-4' : ''"
            color="var(--company-primary)"
            variant="outlined"
            @click="$emit('close-dialog')"
          >
            {{ $t("components.changeActivityDialogDialog.dialog_close_btn") }}
          </v-btn>
          <v-btn
            :block="is_mobile"
            v-else
            class="btn quickfix-btn"
            :class="is_mobile ? 'mt-4' : ''"
            color="var(--company-primary)"
            variant="outlined"
            @click="$emit('prev-step')"
          >
            {{ $i18n.locale === "nl" ? "Stap terug" : "Previous" }}
          </v-btn>
          <k-spacing x="4"></k-spacing>
          <v-btn
            v-if="!is_mobile"
            class="btn text-white"
            color="var(--company-primary)"
            :loading="isSubmitting"
            :disabled="isSubmitting"
            @click="handleRegister"
          >
            {{ submitLabel }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { useMainStore } from "@/stores/store";
import loader from "../loader.vue";
import { debounce } from "lodash";
import api from "@/services/api";
import { formRules } from "@/util/FormRules";
import { asksPhone, toE164 } from "@/util/phone";
import { toAmsterdamCalendarDate } from "@/util/DateUtil";
import functions from "@/util/functions";
import WaitlistBadge from "@/components/waitlist-badge.vue";

// De collegakiezer is een zoekveld (ADR-0071): de server zoekt vanaf twee
// tekens, en een boeking nodigt er hooguit tien uit.
const COLLEAGUE_SEARCH_MIN_CHARS = 2;
const MAX_COLLEAGUES = 10;
export default {
  components: {
    loader,
    WaitlistBadge,
  },
  watch: {
    phone() {
      // Genormaliseerd de payload in; de server doet het nog eens (ADR-0065).
      this.$emit("update-data", { phone: toE164(this.phone) });
    },
    /**
     * Voorvullen met je eigen nummer, zodat je een verouderd nummer kunt
     * corrigeren op het moment dat het ertoe doet (ADR-0065). Voor een ander
     * aanmelden vult niets voor: een werkgever hoort het nummer van zijn
     * medewerker niet te lezen (ADR-0063), alleen te weten of het er is.
     *
     * Als watcher en niet in mounted(): `/v1/users/me/info` wordt bij het
     * opstarten niet ge-await, dus de store-gebruiker kan hier nog leeg zijn.
     * Alleen invullen zolang het veld nog leeg is -- nooit over een correctie
     * heen die de gebruiker net intikte.
     */
    "mainstore.user.phone_e164": {
      handler(value) {
        if (!this.forSomeoneElse && !this.phone && value) {
          this.phone = value;
        }
      },
      immediate: true,
    },
    reminder() {
      this.$emit("update-data", { reminder: this.reminder });
    },
    colleagues() {
      if (this.colleagues.length > MAX_COLLEAGUES) {
        this.colleagues = this.colleagues.slice(0, MAX_COLLEAGUES);
        return;
      }
      // Alleen de ids: meer leest de server niet uit een collega (ADR-0071).
      this.$emit("update-data", {
        colleagues: this.colleagues.map((colleague) => colleague.id),
      });
    },
    colleagueSearch(value) {
      const term = (value || "").trim();
      if (term.length < COLLEAGUE_SEARCH_MIN_CHARS) {
        this.searchColleagues.cancel();
        // Een antwoord dat nog onderweg is, telt niet meer.
        this.colleagueSeq += 1;
        this.colleagueOptions = [];
        this.colleaguesLoading = false;
        return;
      }
      this.searchColleagues(term);
    },
    remark: {
      handler() {
        clearTimeout(this.remarkTimeout); // Clear any existing timeout
        this.remarkTimeout = setTimeout(() => {
          this.$emit("update-data", { remark: this.remark });
        }, 500); // Adjust the delay as needed
      },
      immediate: false, // Ensures it does not run on component mount
    },
  },

  computed: {
    /**
     * De collegakiezer (ADR-0071): alleen met `invite_colleagues` aan, niet bij
     * "tijd wijzigen" -- daar boek je niets -- en niet op de openbare pagina,
     * waar hij ook in legacy niets deed.
     */
    showColleagues() {
      return (
        !this.changing &&
        !this.public_page &&
        !!this.mainstore.companypage?.settings?.invite_colleagues
      );
    },

    /** Wie je al koos blijft staan; bij het maximum kies je er niemand meer bij. */
    colleagueItems() {
      return this.colleagues.length >= MAX_COLLEAGUES
        ? []
        : this.colleagueOptions;
    },

    colleagueNoDataText() {
      if (this.colleagues.length >= MAX_COLLEAGUES) {
        return this.$t("components.registerActivityDialog.invite_max", {
          max: MAX_COLLEAGUES,
        });
      }
      if ((this.colleagueSearch || "").trim().length < COLLEAGUE_SEARCH_MIN_CHARS) {
        return this.$t("components.registerActivityDialog.invite_min_chars");
      }
      return this.$t(
        this.colleaguesLoading
          ? "components.registerActivityDialog.invite_searching"
          : "components.registerActivityDialog.invite_no_results",
      );
    },

    /**
     * Aanmelden voor een ander: dan gaat het nummer over de deelnemer, niet
     * over de invuller.
     */
    forSomeoneElse() {
      return (
        this.registeractivity.enroll_type === "other_enroll" ||
        this.registeractivity.enroll_type === "enroll_new_user"
      );
    },

    /**
     * Wijzigen laat de aanmeldgegevens ongemoeid, en de openbare flow heeft het
     * nummer al in de accountstap gevraagd -- daar tweemaal om vragen is
     * hetzelfde veld twee keer. En een bedrijfspagina kan het vragen uitzetten
     * (ADR-0091).
     */
    showPhone() {
      return (
        !this.changing &&
        !this.public_page &&
        asksPhone(this.mainstore.companypage)
      );
    },

    /**
     * Verplicht zolang de deelnemer geen nummer heeft (ADR-0091). Wie het al
     * gaf hoeft het niet opnieuw in te tikken, en `has_phone` is het enige wat
     * de werkgever daarover te zien krijgt (ADR-0063 / ADR-0065).
     */
    phoneRequired() {
      if (!this.showPhone) return false;

      if (this.registeractivity.enroll_type === "other_enroll") {
        return !this.mainstore.target_user?.has_phone;
      }
      if (this.registeractivity.enroll_type === "enroll_new_user") {
        return true;
      }
      return !this.mainstore.user.phone_e164;
    },

    phoneRules() {
      const rules = [formRules.text_field_rules.isNlPhone];
      if (this.phoneRequired) {
        rules.unshift(
          (value) =>
            !!value ||
            this.$t("components.registerActivityDialog.phone_required"),
        );
      }
      return rules;
    },

    /** Of aanmelden mag: leeg mag, fout nooit, en leeg-maar-verplicht niet. */
    phoneAccepted() {
      if (!this.showPhone) return true;
      if (this.phoneRequired && !this.phone) return false;

      return formRules.text_field_rules.isNlPhone(this.phone) === true;
    },

    /**
     * Een gekozen tijdslot is vol en de wachtlijst staat aan: deze aanmelding
     * wordt een wachtlijstplek (ADR-0058), en de stap zegt dat vóór je klikt.
     */
    hasWaitlist() {
      return (
        !this.changing &&
        (this.registeractivity.dates || []).some((d) =>
          functions.slotWaitlist(d.slot),
        )
      );
    },

    submitLabel() {
      if (this.hasWaitlist) {
        return this.forSomeoneElse
          ? this.$t("waitlist.submit_other")
          : this.$t("waitlist.submit_self");
      }
      const isNl = this.$i18n.locale === "nl";
      if (this.forSomeoneElse) {
        return isNl ? "Ik meld deelnemer aan" : "I sign up participant";
      }
      if (this.changing) {
        return isNl ? "Wijzig aanmelding" : "Change registration";
      }
      return isNl ? "Ik meld mij aan" : "I sign up";
    },

    // De authenticated dialog houdt deze waarde waar zolang de server antwoordt.
    // De openbare dialogen geven hem niet door en behouden hun bestaande korte
    // knopfeedback via `loading`.
    isSubmitting() {
      return this.submitting === true || this.loading;
    },
  },

  methods: {
    // Uit @/util/DateUtil, zodat de template hem kan aanroepen.
    toAmsterdamCalendarDate,
    slotWaitlist: functions.slotWaitlist,
    /** Collega's van deze pagina op naam; alleen het laatste antwoord telt. */
    fetchColleagues(term) {
      const seq = ++this.colleagueSeq;
      this.colleaguesLoading = true;
      api
        .get(`/v1/pages/${this.mainstore.companypage.domain}/colleagues`, {
          params: { search: term },
        })
        .then((res) => {
          if (seq === this.colleagueSeq) {
            this.colleagueOptions = res.data.colleagues || [];
          }
        })
        .catch(() => {
          if (seq === this.colleagueSeq) {
            this.colleagueOptions = [];
          }
        })
        .finally(() => {
          if (seq === this.colleagueSeq) {
            this.colleaguesLoading = false;
          }
        });
    },
    // De melding tonen, ook als het veld nog niet aangeraakt is, en het veld in
    // beeld halen. Het midden, want aan de onderrand plakt de footer.
    revealPhone() {
      const field = this.$refs.phone;
      if (!field) return;
      field.validate();
      field.$el.scrollIntoView({ block: "center" });
      field.focus();
    },
    handleRegister() {
      if (this.isSubmitting) return;
      if (!this.phoneAccepted) {
        this.revealPhone();
        return;
      }

      if (this.submitting === undefined) {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      }
      this.$emit("register");
    },
    formatText() {
      if (this.hasWaitlist) {
        return this.forSomeoneElse
          ? this.$t("waitlist.step_subtitle_other")
          : this.$t("waitlist.step_subtitle_self");
      }
      return this.$i18n.locale === "nl"
        ? this.registeractivity.enroll_type === "other_enroll" ||
          this.registeractivity.enroll_type === "enroll_new_user"
          ? "Leuk dat je een medewerker wilt aanmelden voor:"
          : "Leuk dat jij je aanmeldt voor:"
        : this.registeractivity.enroll_type === "other_enroll" ||
          this.registeractivity.enroll_type === "enroll_new_user"
        ? "Nice of you to sign somebody up for:"
        : "Nice of you to sign up for:";
    },

    getRemarkPlaceholder() {
      return this.$i18n.locale === "nl"
        ? this.registeractivity.enroll_type === "other_enroll" ||
          this.registeractivity.enroll_type === "enroll_new_user"
          ? "Wil je nog iets laten weten voor de medewerker? Heeft hij/zij een specifieke vraag of wens? Vertel het hier!"
          : "Wil je ons nog iets laten weten? Heb je bijvoorbeeld een specifieke vraag of wens? Vertel het hier!"
        : this.registeractivity.enroll_type === "other_enroll" ||
          this.registeractivity.enroll_type === "enroll_new_user"
        ? "Would you like to let us know something for the employee? Do they have a specific question or request? Tell us here!"
        : "Would you like to let us know something? Do you have a specific question or request? Tell us here!";
    },

    getRemarkInfoText() {
      return this.$i18n.locale === "nl"
        ? this.registeractivity.enroll_type === "other_enroll" ||
          this.registeractivity.enroll_type === "enroll_new_user"
          ? "Zijn/haar gegevens zijn veilig bij ons en worden alleen intern gebruikt. We delen persoonlijke informatie niet met anderen."
          : "Je gegevens zijn veilig bij ons en worden alleen intern gebruikt. We delen je persoonlijke informatie niet met je werkgever of anderen."
        : this.registeractivity.enroll_type === "other_enroll" ||
          this.registeractivity.enroll_type === "enroll_new_user"
        ? "Their data is safe with us and will only be used internally. We do not share personal information with others."
        : "Your data is safe with us and will only be used internally. We do not share your personal information with your employer or others.";
    },

    getReminderLabel() {
      return this.$i18n.locale === "nl"
        ? this.registeractivity.enroll_type === "other_enroll" ||
          this.registeractivity.enroll_type === "enroll_new_user"
          ? "Ja, stuur hem/haar een herinneringsmail"
          : "Ja, stuur mij een herinneringsmail"
        : this.registeractivity.enroll_type === "other_enroll" ||
          this.registeractivity.enroll_type === "enroll_new_user"
        ? "Yes, send them a reminder email"
        : "Yes, send me a reminder email";
    },
  },
  created() {
    // Zoekt terwijl je typt, maar niet bij elke toetsaanslag.
    this.searchColleagues = debounce(this.fetchColleagues, 300);
  },
  mounted() {
    debounce(() => {
      this.ready = true;
    }, 300)();
  },
  beforeUnmount() {
    this.searchColleagues.cancel();
  },
  data: () => ({
    reminder: true,
    ready: false,
    remark: "",
    phone: "",
    loading: false,
    colleagues: [],
    colleagueSearch: "",
    colleagueOptions: [],
    colleaguesLoading: false,
    colleagueSeq: 0,
    mainstore: useMainStore(),
  }),
  props: [
    "registeractivity",
    "activity",
    "locationIndex",
    "locale",
    "stepTotal",
    "is_mobile",
    "page",
    "stepLabel",
    "enroll",
    "changing",
    "firstStep",
    // Alleen de ingelogde flow geeft dit door; de openbare flow behoudt zijn
    // bestaande loadinggedrag.
    "submitting",
    // De openbare flow vraagt het nummer al in de accountstap ervoor.
    "public_page",
  ],
};
</script>
